import PromiseQueue from './PromiseQueue';
export function addPQueuePlugin(Vue) {
    Vue.prototype.$promiseQueue = Vue.observable(new PromiseQueue());
}
